import React, { useState } from 'react';
import { Row, Col, Table, Input, Button, Space, Tooltip, Typography, Image, Card } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

function P450Table({ data, loading }) {

	const Bucket = "https://d1en57qlwrlmqu.cloudfront.net/P450/20260618"

	const [state, setState] = useState({
		searchText: '',
		searchedColumn: '',
	});

	var searchInput;

	const getColumnSearchProps = dataIndex => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={node => {
						searchInput = node;
					}}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ marginBottom: 8, display: 'block' }}
				/>
				<Space>
					<Button
						type="primary"
						onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
						icon={<SearchOutlined />}
						// size="small"
						style={{ width: 90 }}
					>
						Search
					</Button>
					<Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
						Reset
					</Button>
				</Space>
			</div>
		),
		filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
		onFilter: (value, record) =>
			record[dataIndex]
				? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
				: '',
		onFilterDropdownVisibleChange: visible => {
			if (visible) {
				setTimeout(() => searchInput.select(), 100);
			}
		},
		render: text =>
			state.searchedColumn === dataIndex ? (
				<Tooltip placement="topLeft" title={
					<Highlighter
						highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
						searchWords={[state.searchText]}
						autoEscape
						textToHighlight={text ? text.toString() : ''}
					/>
				}>
					<Highlighter
						highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
						searchWords={[state.searchText]}
						autoEscape
						textToHighlight={text ? text.toString() : ''}
					/>
				</Tooltip>
			) : (
				<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
			),
	});

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setState({
			searchText: selectedKeys[0],
			searchedColumn: dataIndex,
		});
	};

	const handleReset = clearFilters => {
		clearFilters();
		setState({ searchText: '' });
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: 'ID',
			key: 'ID',
			sorter: (a, b) => a.ID.localeCompare(b.ID),
			...getColumnSearchProps('ID'),
		},
		{
			title: 'Family',
			dataIndex: 'Family',
			key: 'Family',
			sorter: (a, b) => a.Family.localeCompare(b.Family),
			...getColumnSearchProps('Family'),
		},
		{
			title: 'Kindom',
			dataIndex: 'Kindom',
			key: 'Kindom',
			filters: [
				{
					text: 'Archaea',
					value: 'Archaea',
				},
				{
					text: 'Bacteria',
					value: 'Bacteria',
				},
				{
					text: 'Fungi',
					value: 'Fungi',
				},
				{
					text: 'Metazoa',
					value: 'Metazoa',
				},
				{
					text: 'Viridiplantae',
					value: 'Viridiplantae',
				},
				{
					text: 'Virus',
					value: 'Virus',
				},
				{
					text: 'OtherEukaryotes',
					value: 'OtherEukaryotes',
				}
			],
			onFilter: (value, record) => record.Kindom.indexOf(value) === 0,
			// sorter:(a,b)=>a.Kindom.localeCompare(b.Kindom),
			// ...getColumnSearchProps('Kindom'),
		},
		{
			title: 'Function',
			dataIndex: 'Function',
			key: 'Function',
			sorter: (a, b) => a.Function.localeCompare(b.Function),
			...getColumnSearchProps('Function'),
		},
		{
			title: 'Chemical Equation',
			key: 'Chemical Equation',

			width: 200,
			render: (_, record) => (
				<Space size="middle">
					<Image
						width={200}
						src={`${Bucket}/img_reaction/${record.ID}.png`}
					/>
				</Space>
			),
		},
		{
			title: 'FASTA Sequence',
			key: 'FASTA Sequence',

			width: 100,
			render: (_, record) => (
				<Space size="middle">
					<Typography.Link href={`${Bucket}/FASTA/${record.ID}.fasta`} target="_blank">
						FASTA
					</Typography.Link>
				</Space>
			),
		},
		{
			title: 'PDB Format',
			key: 'PDB Format',

			width: 100,
			render: (_, record) => (
				<Space size="middle">
					<Typography.Link href={`${Bucket}/PDB/${record.ID}.pdb`} target="_blank">
						PDB
					</Typography.Link>
				</Space>
			),
		},
		{
			title: 'Reference',
			key: 'Reference',

			width: 100,
			render: (_, record) => (
				<Space size="middle">
					<Typography.Link href={record.DOI} target="_blank" rel="noopener noreferrer">
						DOI
					</Typography.Link>
				</Space>
			),
		}
	];



	return (
		<Table
			bordered
			columns={columns}
			dataSource={data}
			loading={loading}
			rowKey="ID"
			pagination={true}
		/>

	);
}

export default P450Table;
